'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  encr(encryptionConfig, text) {
    const { algorithm, key, iv } = encryptionConfig;
    const cipher = _crypto2.default.createCipher(algorithm, key, iv);
    let crypted = cipher.update(text, 'utf8', 'hex');
    crypted += cipher.final('hex');
    return crypted;
  },
  serializeEncr(encryptionConfig, object) {
    return this.encr(encryptionConfig, (0, _stringify2.default)(object));
  },
  decr(encryptionConfig, text) {
    const { algorithm, key, iv } = encryptionConfig;
    const decipher = _crypto2.default.createDecipher(algorithm, key, iv);
    let dec = decipher.update(text, 'hex', 'utf8');
    dec += decipher.final('utf8');
    return dec;
  },
  serializeDecr(encryptionConfig, text) {
    return JSON.parse(this.decr(encryptionConfig, text));
  }
};